<template>
  <div>
    <!-- <img src="http://127.0.0.1:8000/storage/svgs/us-open-22.svg" style="width:100%;float:left;" /> -->
    <csr-dashboard v-if="$store.state.user && $store.state.user.user_type === 'csr'"></csr-dashboard>
    <rep-dashboard v-if="$store.state.user && $store.state.user.user_type === 'rep' || $store.state.user && $store.state.user.user_type === 'universal_rep'"></rep-dashboard>
    <admin-assistant-dashboard v-if="$store.state.user && $store.state.user.user_type === 'admin_assistant'"></admin-assistant-dashboard>
  </div>
</template>

<script>
import CsrDashboard from './components/csr_dashboard'
import RepDashboard from './components/rep_dashboard'
import AdminAssistantDashboard from './components/admin_assistant_dashboard'

export default {
  name: 'Dashboard',
  components: {
    CsrDashboard,
    RepDashboard,
    AdminAssistantDashboard
  },
  data () {
    return {

    }
  },
  methods: {
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    }
  }
}
</script>
